@use '~@frontrow/console/css/variables.scss';

.importRow {
  display: flex;
  margin: variables.$std-margin-2xl;
  align-items: center;
}

.title {
  font-size: variables.$font-size-md;
  text-transform: capitalize;
}

.rowDescription {
  width: 500px;
}

.uploadBtn b {
  color: #428bca;
}

.uploadedCheck {
  width: 20px;
  height: 20px;
  margin-left: variables.$std-margin-md;
  color: #4bcfbe;
}
